import { useRef, useState } from 'react';
import constate from 'constate';
import Player from 'react-player/file';
const SRC = 'selector.provider.ts';

import { getInternalPlayer } from 'components/app/_helpers/_app.helper';

const useSelectorProvider = () => {
  const srListenClip = useRef<ClipId | null>(null);
  const srPlayerRef = useRef<Player | null>(null);
  const [isHighlightSensitivityActive, setIsHighlightSensitivityActive] = useState(false);

  const srPlayerPlay = (value: boolean) => {
    const player = getInternalPlayer(srPlayerRef.current);
    if (!player) {
      console.error(`[${SRC}] srPlayerPlay`);
      return;
    }
    if (value) player.play();
    else player.pause();
  };

  return { srPlayerRef, srPlayerPlay, srListenClip, isHighlightSensitivityActive, setIsHighlightSensitivityActive };
};

export const [SelectorProvider, useSelectorContext] = constate(useSelectorProvider);
